module.exports = __webpack_public_path__ + "media/img/trainee-program/card_cv-fb4fa45f04c2e8e0343839750deb4b2f.png";